<label
  [attr.for]="htmlFor || for"
  [ngClass]="
    'mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400 ' + className
  "
>
  <ng-content></ng-content>
  @if (required) {
    <span class="text-red-500 ml-1">*</span>
  }
</label>